import { createComputed } from "solid-js"
import { useLanguage } from "@/context/language"
import type { CoworkApprovalReview, CoworkPortfolioApproval } from "@/cowork/api"
import { ReviewView } from "@/pages/cowork-review"
import { useDialog } from "@opencode-ai/ui/context/dialog"
import { DialogBody, DialogHeader, DialogTitle, DialogV2 } from "@opencode-ai/ui/v2/dialog-v2"

export function ApprovalDetailDialog(props: {
  approval: CoworkPortfolioApproval
  active: () => boolean
  onUpdated: (value: CoworkApprovalReview) => void
}) {
  const language = useLanguage()
  const dialog = useDialog()
  const approval = props.approval
  createComputed(() => {
    if (!props.active()) dialog.close()
  })
  return (
    <DialogV2 containerClass="!h-[calc(100dvh_-_32px)] !max-h-[calc(100dvh_-_32px)] !w-[min(calc(100vw_-_32px),1600px)]">
      <DialogHeader closeLabel={language.t("common.close")}>
        <DialogTitle>{language.t("cowork.enterprise.approvals.details")}</DialogTitle>
      </DialogHeader>
      <DialogBody class="min-h-0 flex-1 overflow-hidden !p-0">
        <ReviewView approvalID={approval.id} workspace={{
          projectID: approval.project_id,
          companyID: approval.company_id,
          label: [approval.company_name, approval.project_name, approval.period_name].filter(Boolean).join(" / "),
        }} onUpdated={(value) => { if (props.active()) props.onUpdated(value) }} />
      </DialogBody>
    </DialogV2>
  )
}
